// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/DMSerifDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/heebo.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Serif";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "Heebo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
:root {
  --muted-text: #959DA5;
  --primary-color: #484f4f;
  --purple: #6A4FA4;
  /*#33004e;*/
  --background-color: #eeeeee;
  --separator-color: #cbcbcb;
  --header-image-size: 8.5rem;
}

/* Dark mode colour scheme */
@media screen and (prefers-color-scheme: dark) {
  :root {
    --muted-text: #757575;
    --primary-color: #e0e0e0;
    --purple: #6A4FA4;
    /*#33004e;*/
    --background-color: #121212;
    --separator-color: #343434;
    --header-image-size: 8.5rem;
  }
}
* {
  --text-shadow: 2px 2px rgba(255, 255, 255, .1);
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

body {
  border-top: 0.5rem solid var(--purple);
  user-select: none;
  font-family: "DM Serif", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--background-color);
  color: var(--primary-color);
}

#wrapper {
  min-height: calc(100vh - 0.5rem);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 2rem;
  text-shadow: var(--text-shadow);
  width: 20%;
  text-align: center;
}
#wrapper small {
  margin-top: 0.5rem;
  border-top: 1px solid var(--separator-color);
  text-shadow: none;
  font-size: 1rem;
  padding-top: 0.5rem;
  text-transform: lowercase;
  font-family: "Heebo";
  font-weight: 400;
  color: var(--muted-text);
}
#wrapper h1,
#wrapper h3 {
  font-weight: normal;
}
#wrapper h1 {
  font-size: 3rem;
  text-shadow: var(--text-shadow);
}
#wrapper h3 {
  font-size: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,4CAAA;AACJ;AAEA;EACI,oBAAA;EACA,4CAAA;AAAJ;AAGA;EACI,qBAAA;EACA,wBAAA;EACA,iBAAA;EACA,WAAA;EACA,2BAAA;EACA,0BAAA;EAEA,2BAAA;AAFJ;;AAKA,4BAAA;AACA;EACI;IACI,qBAAA;IACA,wBAAA;IACA,iBAAA;IACA,WAAA;IACA,2BAAA;IACA,0BAAA;IAEA,2BAAA;EAHN;AACF;AAMA;EACI,8CAAA;EAEA,sBAAA;EACA,UAAA;EACA,SAAA;AALJ;;AAQA;EACI,sCAAA;EACA,iBAAA;EAEA,mCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mCAAA;EACA,2BAAA;AAPJ;;AAUA;EACI,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,+BAAA;EACA,UAAA;EACA,kBAAA;AAPJ;AASI;EACI,kBAAA;EACA,4CAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,wBAAA;AAPR;AAUI;;EAEI,mBAAA;AARR;AAWI;EACI,eAAA;EACA,+BAAA;AATR;AAYI;EACI,eAAA;AAVR","sourcesContent":["@font-face {\n    font-family: 'DM Serif';\n    src: url('../assets/fonts/DMSerifDisplay-Regular.ttf');\n}\n\n@font-face {\n    font-family: 'Heebo';\n    src: url('../assets/fonts/heebo.ttf');\n}\n\n:root {\n    --muted-text: #959DA5;\n    --primary-color: #484f4f;\n    --purple: #6A4FA4;\n    /*#33004e;*/\n    --background-color: #eeeeee;\n    --separator-color: #cbcbcb;\n\n    --header-image-size: 8.5rem;\n}\n\n/* Dark mode colour scheme */\n@media screen and (prefers-color-scheme: dark) {\n    :root {\n        --muted-text: #757575;\n        --primary-color: #e0e0e0;\n        --purple: #6A4FA4;\n        /*#33004e;*/\n        --background-color: #121212;\n        --separator-color: #343434;\n\n        --header-image-size: 8.5rem;\n    }\n}\n\n* {\n    --text-shadow: 2px 2px rgba(255, 255, 255, .1);\n\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n}\n\nbody {\n    border-top: .5rem solid var(--purple);\n    user-select: none;\n\n    font-family: 'DM Serif', sans-serif;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background: var(--background-color);\n    color: var(--primary-color);\n}\n\n#wrapper {\n    min-height: calc(100vh - 0.5rem);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    font-size: 2rem;\n    text-shadow: var(--text-shadow);\n    width: 20%;\n    text-align: center;\n\n    small {\n        margin-top: 0.5rem;\n        border-top: 1px solid var(--separator-color);\n        text-shadow: none;\n        font-size: 1rem;\n        padding-top: 0.5rem;\n        text-transform: lowercase;\n        font-family: 'Heebo';\n        font-weight: 400;\n        color: var(--muted-text);\n    }\n\n    h1,\n    h3 {\n        font-weight: normal;\n    }\n\n    h1 {\n        font-size: 3rem;\n        text-shadow: var(--text-shadow);\n    }\n\n    h3 {\n        font-size: 2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
